<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <div class="btn-group-one">
            <el-button type="primary" size="small" @click="addTable">新建桌位</el-button>
          </div>
          <div class="btn-group-two">
            <el-checkbox
              v-if="downloadQrcodeVisible"
              :indeterminate="isIndeterminate"
              v-model="allChecked"
              label="全选"
              border
              @change="checkAllChange"
              size="small"
            ></el-checkbox>
            <el-button
              v-if="downloadQrcodeVisible"
              plain
              :disabled="isSel ? false : true"
              size="small"
              @click="batchDownloadQrcode"
              >下载点餐码</el-button
            >
            <el-button
              plain
              :disabled="regionActive == '0' ? true : false"
              size="small"
              @click="transferTable"
              >桌位转区</el-button
            >
            <el-button type="primary" size="small" @click="openAutoCreate"
              >自动生成桌位</el-button
            >
          </div>
        </div>
        <div class="header-right">
          <el-input
            placeholder="输入桌位号"
            v-model="searchInput"
            class="input-search"
            size="small"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchTable"
            ></el-button>
          </el-input>
        </div>
      </div>
      <div class="tab-content" v-loading="isTableListLoad">
        <el-tabs v-model="regionActive" type="card">
          <el-tab-pane
            v-for="(item, index) in regionList"
            :key="String(item.shopAreaId)"
            :label="item.areaName"
            :value="String(index)"
          ></el-tab-pane>
        </el-tabs>
        <div class="list">
          <el-checkbox-group v-model="checkedTableList" @change="checkedTableChange">
            <el-table :data="currentTableList" style="width: 100%">
              <el-table-column label="桌位类型">
                <template slot-scope="scope">
                  <el-checkbox :label="scope.row.shoppingTableId">
                    <div class="name">{{ scope.row.tableConfigName }}</div>
                  </el-checkbox>
                </template>
              </el-table-column>
              <el-table-column label="桌位号">
                <template slot-scope="scope">
                  <div class="item-count">
                    {{ scope.row.tableName }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="平台点餐码"
                align="center"
                v-if="userFuncInfo && userFuncInfo.userFuncStatus == 30"
              >
                <template slot-scope="scope">
                  <el-button
                    size="small"
                    type="primary"
                    @click="bindCodeEdit(scope.$index, 1)"
                    plain
                    >绑定</el-button
                  >
                  <el-button
                    size="small"
                    type="primary"
                    @click="createAppltQrcode(scope.$index, 1)"
                    plain
                  >
                    查看
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="自定义绑定码">
                <template slot-scope="scope">
                  <div class="item-count">{{ scope.row.bindCode }}</div>
                </template>
              </el-table-column>
              <el-table-column width="500" label="操作" header-align="right">
                <template slot-scope="scope">
                  <div class="float-right">
                    <el-button
                      size="small"
                      :type="scope.row.bindCode ? 'danger' : 'primary'"
                      @click="
                        scope.row.bindCode
                          ? unbundling(scope.$index)
                          : bindCodeEdit(scope.$index)
                      "
                      plain
                      >{{ scope.row.bindCode ? "解绑" : "绑定二维码" }}</el-button
                    >
                    <el-button
                      size="small"
                      type="primary"
                      @click="createAppltQrcode(scope.$index)"
                      plain
                    >
                      生成小程序码
                    </el-button>
                    <el-button
                      v-if="downloadQrcodeVisible"
                      size="small"
                      type="primary"
                      @click="downloadQrcode(scope.$index)"
                      plain
                    >
                      <img
                        style="position: absolute; z-index: -9"
                        :id="`codeImage${scope.$index}`"
                        :src="scope.row.codeImage"
                        alt
                      />
                      下载点餐码
                    </el-button>
                    <el-button
                      size="small"
                      type="primary"
                      @click="edit(scope.$index)"
                      plain
                      >编辑</el-button
                    >
                    <el-button
                      size="small"
                      plain
                      @click="delTable(scope.row.shoppingTableId)"
                      >删除</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-checkbox-group>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="pageNo"
            :page-size="pageSize"
            background
            layout="prev, pager, next, jumper"
            :total="totalPage"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogAddTableVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="510px"
    >
      <div slot="title" class="dialog-title">
        {{ addTableForm.shoppingTableId ? "编辑桌位" : "新建桌位" }}
      </div>
      <el-form
        :model="addTableForm"
        :rules="addTableFormRule"
        ref="addTableForm"
        label-width="68px"
        class="demo-ruleForm"
        :hide-required-asterisk="true"
      >
        <el-form-item label="桌位区域" prop="shopAreaId">
          <el-select v-model="addTableForm.shopAreaId" placeholder="请选择桌位区域">
            <el-option
              v-for="(item, index) in selRegionList"
              :key="index"
              :label="item.areaName"
              :value="item.shopAreaId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="桌位类型" prop="shoppingTableConfigId">
          <el-select
            v-model="addTableForm.shoppingTableConfigId"
            placeholder="请选择桌位类型"
          >
            <el-option
              v-for="(item, index) in classifyList"
              :key="index"
              :label="`${item.tableConfigName}(${item.min}-${item.max}人)`"
              :value="item.shoppingTableConfigId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="桌位名称" prop="tableName">
          <el-input
            v-model="addTableForm.tableName"
            :maxlength="15"
            placeholder="请填写桌位名称（如001，A01）"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createTable" :loading="isSubmit">{{
          addTableForm.shoppingTableId ? "提交编辑" : "立即创建"
        }}</el-button>
        <el-button @click="dialogAddTableVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogBindCodeVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="510px"
    >
      <div slot="title" class="dialog-title">绑定二维码</div>
      <el-form
        :model="bindCodeForm"
        :rules="bindCodeFormRule"
        ref="bindCodeForm"
        label-width="68px"
        class="demo-ruleForm"
        :hide-required-asterisk="true"
      >
        <el-form-item label="绑定号码" prop="tableName">
          <el-input
            v-model="bindCodeForm.bindCode"
            :maxlength="8"
            placeholder="请填写二维码绑定号码"
            type="number"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="bindCode" :loading="isSubmit">{{
          "立即绑定"
        }}</el-button>
        <el-button @click="dialogBindCodeVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="transferTableVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="580px"
      class="transfer-body"
    >
      <el-transfer
        v-model="transferTableList"
        :props="{
          key: 'shoppingTableId',
          label: 'tableName',
        }"
        :titles="['不在本区域的桌子', '当前区域的桌子']"
        :data="allTableList"
      ></el-transfer>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveTransfer" :loading="isSubmit"
          >保存</el-button
        >
        <el-button @click="transferTableVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogAutoCreateVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="580px"
    >
      <div slot="title" class="dialog-title">{{ "自动生成桌位" }}</div>
      <el-form
        :model="autoCreateForm"
        :rules="autoCreateFormRule"
        ref="autoCreateForm"
        label-width="68px"
        class="demo-ruleForm"
        :hide-required-asterisk="true"
      >
        <el-form-item label="餐桌数量" prop="tableName">
          <el-input
            v-model="autoCreateForm.tableCount"
            :maxlength="15"
            placeholder="请填写餐桌数量"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="autoCreate" :loading="isSubmit">确定</el-button>
        <el-button @click="dialogAutoCreateVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="visibleAppltQrcodeImg"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="380px"
    >
      <div style="text-align: center">
        <img class="applt-qrcode" :src="appltQrcodeImg" alt="" v-if="isImg" />
        <qrcode
          v-else
          :value="appltQrcodeImg"
          :options="{ size: 300 }"
          class="applt-qrcode"
        ></qrcode>
        <el-button type="primary" @click="downPayCode">下载小程序码</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getShopAreas,
  getShopTables,
  getShopTableConfigs,
  delEdcShopTable,
  updateEdcShopTable,
  updateShoppingTableBindCode,
  moveShopTables,
  autoCreateEdcShopTable,
  addQrCodeJumpTableNumber,
  bindWhdcQrCode,
  whdcQrCode,
  getTableWxCode,
} from "@/api";
import request from "@/utils/request";
import FileSaver from "file-saver";
import Jszip from "jszip";
import html2canvas from "html2canvas";
import qrcode from "@xkeshi/vue-qrcode";
import { mapState } from "vuex";
export default {
  data() {
    return {
      allChecked: false,
      isIndeterminate: false,
      isSel: false,
      checkedTableList: [],
      searchInput: "",
      regionList: [],
      selRegionList: [],
      currentTableList: [],
      allTableList: [],
      transferTableList: [],
      classifyList: [],
      regionActive: "0",
      pageNo: 1,
      pageSize: 5,
      totalPage: 0,
      dialogAddTableVisible: false,
      transferTableVisible: false,
      dialogAutoCreateVisible: false,
      dialogBindCodeVisible: false,
      addTableForm: {
        shopAreaId: "",
        shoppingTableConfigId: "",
        tableName: "",
        capacity: 1,
      },
      bindCodeForm: {
        shoppingTableConfigId: "",
        tableName: "",
        capacity: 1,
        bindCode: "",
      },
      bindCodeType: 0,
      bindCodeFormRule: {
        bindCode: [
          {
            required: true,
            message: "请输入二维码绑定号码",
            trigger: "blur",
          },
        ],
      },
      addTableFormRule: {
        shopAreaId: [
          {
            required: true,
            message: "请选择桌位区域",
            trigger: "blur",
          },
        ],
        shoppingTableConfigId: [
          {
            required: true,
            message: "请选择桌位类型",
            trigger: "blur",
          },
        ],
        tableName: [
          {
            required: true,
            message: "请输入桌位名称",
            trigger: "blur",
          },
        ],
      },
      isTableListLoad: false,
      isSubmit: false,
      autoCreateForm: {
        tableCount: "",
      },
      autoCreateFormRule: {
        tableCount: [
          {
            required: true,
            message: "请输入餐桌数量",
            trigger: "blur",
          },
        ],
      },
      appltQrcodeImg: "",
      visibleAppltQrcodeImg: false,
      isImg: false,
    };
  },
  components: {
    qrcode,
  },
  computed: {
    ...mapState({
      userFuncInfo: (state) => state.userFuncInfo,
    }),
    tableListOptions() {
      let options = [];
      this.currentTableList.forEach((val) => {
        options.push(val.shoppingTableId);
      });
      return options;
    },
    downloadQrcodeVisible() {
      return !!~location.href.indexOf("wei.gg") || !!~location.href.indexOf("192.168");
    },
  },
  watch: {
    regionActive(val) {
      this.pageNo = 1;
      this.searchInput = "";
      this.resetCheckedState();
      this.getNextData();
    },
    searchInput(val) {
      if (!val) {
        this.pageSize = 5;
        this.getNextData();
      }
    },
  },
  mounted() {
    if (this.$route.query.type == "addtable") {
      this.dialogAddTableVisible = true;
    }
    this.getPageData();
  },
  methods: {
    getPageData() {
      this.getShopAreas();
      this.getShopTableConfigs();
    },
    getNextData() {
      this.getShopTables();
      this.getShopTablesNum();
    },
    getShopAreas() {
      getShopAreas().then((res) => {
        if (res.code == 1) {
          let data = JSON.parse(JSON.stringify(res.data));
          this.selRegionList = JSON.parse(JSON.stringify(res.data));
          this.regionList = data;
        } else {
          this.selRegionList = [];
          this.regionList = [];
          this.isTableListLoad = false;
        }
        this.regionList.unshift({
          areaName: "全部",
          shopAreaId: "",
          shopId: "",
        });
        if (this.selRegionList.length) {
          this.getNextData();
        }
      });
    },
    getShopTableConfigs() {
      getShopTableConfigs({
        row: 1000,
      }).then((res) => {
        if (res.code == 1) {
          this.classifyList = res.data;
        }
        if (res.code == -1) {
          this.classifyList = [];
        }
      });
    },
    getShopTables() {
      this.isTableListLoad = true;
      getShopTables({
        pageNo: this.pageNo,
        shopAreaId: this.regionList[this.regionActive].shopAreaId,
        row: this.pageSize,
        tableName: this.searchInput,
      }).then((tablesRes) => {
        if (tablesRes.code == 1) {
          tablesRes.data.forEach((val) => {
            val.codeImage = `${request.baseUrl}/edcmanageapi/Shop_codeImage?tableName=${val.tableName}&edcShopQRcodeValue=${val.edcShopQRcodeValue}&userId=${localStorage.userId}&sessionId=${localStorage.sessionId}`;
          });
          this.currentTableList = tablesRes.data;
        } else {
          this.currentTableList = [];
        }
        this.isTableListLoad = false;
      });
    },
    getShopTablesNum() {
      this.isTableListLoad = true;
      getShopTables({
        shopAreaId: this.regionList[this.regionActive].shopAreaId,
        row: 1000,
        tableName: this.searchInput,
      }).then((tablesRes) => {
        if (tablesRes.code == 1) {
          this.totalPage = tablesRes.data.length;
          if (this.pageNo > this.totalPage / this.pageSize) {
            this.pageNo = Math.ceil(this.totalPage / this.pageSize);
            this.getShopTables();
          }
          this.isTableListLoad = false;
          this.transferTableList = [];
          tablesRes.data.forEach((val) => {
            this.transferTableList.push(val.shoppingTableId);
          });
        }
        if (tablesRes.code == -1) {
          this.totalPage = 0;
          this.transferTableList = [];
          this.isTableListLoad = false;
        }
      });
    },
    addTable() {
      this.addTableForm = {
        shopAreaId: "",
        shoppingTableConfigId: "",
        tableName: "",
        capacity: 1,
      };
      this.dialogAddTableVisible = true;
    },
    updateEdcShopTable(params) {
      this.isSubmit = true;
      updateEdcShopTable(params).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: params.shoppingTableId ? "编辑成功" : "新增成功",
            type: "success",
            duration: 2000,
          });
          if (!params.shoppingTableId) {
            this.pageNo = 1;
          }
          this.dialogAddTableVisible = false;
          this.dialogBindCodeVisible = false;
          this.getNextData();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
        setTimeout(() => {
          this.isSubmit = false;
        }, 500);
      });
    },
    updateShoppingTableBindCode(params) {
      this.isSubmit = true;
      updateShoppingTableBindCode(params).then((res) => {
        if (res.code == 1) {
          console.log(params);
          this.$notify({
            title: "提示",
            message: params.bindCode ? "绑定成功" : "解绑成功",
            type: "success",
            duration: 2000,
          });
          if (!params.shoppingTableId) {
            this.pageNo = 1;
          }
          this.dialogBindCodeVisible = false;
          this.getNextData();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
        setTimeout(() => {
          this.isSubmit = false;
        }, 500);
      });
    },
    transferTable() {
      getShopTables({
        shopAreaId: "",
        row: 1000,
      }).then((tablesRes) => {
        if (tablesRes.code == 1) {
          this.allTableList = tablesRes.data;
          this.transferTableVisible = true;
        }
      });
    },
    saveTransfer() {
      this.isSubmit = true;
      let list = JSON.parse(JSON.stringify(this.transferTableList));
      list = list.join(",");
      moveShopTables({
        tableList: list,
        shopAreaId: this.regionList[this.regionActive].shopAreaId,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "转区成功",
            type: "success",
            duration: 2000,
          });
          this.getNextData();
          this.transferTableVisible = false;
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
        setTimeout(() => {
          this.isSubmit = false;
        }, 500);
      });
    },
    resetCheckedState() {
      this.allChecked = false;
      this.isIndeterminate = false;
      this.isSel = false;
      this.checkedTableList = [];
    },
    checkAllChange(val) {
      this.checkedTableList = val ? this.tableListOptions : [];
      this.isIndeterminate = false;
      this.isSel = val;
      this.allChecked = val;
    },
    checkedTableChange(value) {
      let checkedCount = value.length;
      this.allChecked = checkedCount === this.currentTableList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.currentTableList.length;
      this.isSel = checkedCount > 0;
    },
    searchTable() {
      if (!this.searchInput) {
        this.$notify({
          title: "提示",
          message: "请输入搜索桌位号",
          type: "warning",
          duration: 1000,
        });
        return;
      }
      this.pageNo = 1;
      this.pageSize = 1000;
      this.getNextData();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.resetCheckedState();
      this.getShopTables();
    },
    edit(index) {
      let params = JSON.parse(JSON.stringify(this.currentTableList[index]));
      this.addTableForm = params;
      this.dialogAddTableVisible = true;
    },
    bindCodeEdit(index, type = 0) {
      let params = JSON.parse(JSON.stringify(this.currentTableList[index]));
      params.bindCode = "";
      this.bindCodeForm = params;
      this.bindCodeType = type;
      this.dialogBindCodeVisible = true;
    },
    unbundling(index) {
      let params = JSON.parse(JSON.stringify(this.currentTableList[index]));
      this.bindCodeForm = params;
      this.bindCodeForm.bindCode = "";
      this.updateShoppingTableBindCode(this.bindCodeForm);
    },
    delTable(id) {
      this.$msgbox({
        title: "消息",
        message: `是否删除，删除后将无法恢复！`,
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            delEdcShopTable({
              shoppingTableId: id,
            }).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "删除成功",
                  type: "success",
                  duration: 2000,
                });
                this.getNextData();
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
            });
            done();
          } else {
            done();
          }
        },
      }).then((action) => {});
    },
    batchDownloadQrcode() {
      let isEnd = false;
      let zip = new Jszip();
      var img = zip.folder("images");
      this.currentTableList.forEach((val, index) => {
        if (~this.checkedTableList.indexOf(val.shoppingTableId)) {
          html2canvas(document.getElementById(`codeImage${index}`), {
            useCORS: true,
            width: 1040,
            height: 1560,
          }).then((canvas) => {
            let dataURL = canvas.toDataURL();
            img.file(
              `${this.currentTableList[index].tableName}.png`,
              dataURL.substring(22),
              { base64: true }
            );
            if (index == this.checkedTableList.length - 1) {
              zip.generateAsync({ type: "blob" }).then(function (content) {
                FileSaver.saveAs(content, "tables.zip");
              });
            }
          });
        }
      });
    },
    downloadQrcode(index) {
      html2canvas(document.getElementById(`codeImage${index}`), {
        useCORS: true,
        width: 1040,
        height: 1560,
      }).then((canvas) => {
        let dataURL = canvas.toDataURL("image/jpeg", 1.0);
        var a = document.createElement("a"); // 创建一个a节点插入的document
        var event = new MouseEvent("click"); // 模拟鼠标click点击事件
        a.download = `${this.currentTableList[index].tableName}.png`; // 设置a节点的download属性值
        a.href = dataURL; // 将图片的src赋值给a节点的href
        a.dispatchEvent(event);
      });
    },
    createAppltQrcode(index, type = 0) {
      console.log(this.currentTableList[index]);
      let table = this.currentTableList[index];
      if (!type) {
        if (!!~location.href.indexOf("youke.ink")) {
          this.isImg = true;
          if (table.wxQrCode) {
            this.appltQrcodeImg = table.wxQrCode;
            this.visibleAppltQrcodeImg = true;
          } else {
            getTableWxCode({
              qrCodeValue: `${localStorage.shopId + "-" + String(table.shoppingTableId)}`,
            }).then((res) => {
              if (res.code == 1) {
                // this.appltQrcodeImg = res.data.imgUrl;
                this.appltQrcodeImg = res.data.url;
                this.visibleAppltQrcodeImg = true;
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
            });
          }
        } else {
          addQrCodeJumpTableNumber({
            // shopId: localStorage.shopId,
            // page: "pages/index/index",
            // scene: `qrCodeValue=${localStorage.shopId +
            //   "-" +
            //   String(table.shoppingTableId)}&mtype=3`,
            qrCodeValue: `${localStorage.shopId + "-" + String(table.shoppingTableId)}`,
          }).then((res) => {
            if (res.code == 1) {
              // this.appltQrcodeImg = res.data.imgUrl;
              this.appltQrcodeImg = res.data.url;
              this.visibleAppltQrcodeImg = true;
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "error",
                duration: 2000,
              });
            }
          });
        }
      }
      if (type == 1) {
        whdcQrCode({
          mtype: 3,
          shoppingTableId: table.shoppingTableId,
        }).then((res) => {
          if (res.code == 1) {
            this.appltQrcodeImg = res.data.url;
            this.visibleAppltQrcodeImg = true;
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 2000,
            });
          }
        });
      }
    },
    downPayCode() {
      if (this.isImg) {
        window.open(document.querySelector(".applt-qrcode").src, "_blank");
        // html2canvas(document.querySelector(".applt-qrcode"), {
        //   useCORS: true,
        //   width: 1024,
        //   height: 1024,
        // }).then((canvas) => {
        //   let dataURL = canvas.toDataURL("image/jpeg", 1.0);
        //   var a = document.createElement("a"); // 创建一个a节点插入的document
        //   var event = new MouseEvent("click"); // 模拟鼠标click点击事件
        //   a.download = `qrcode.png`; // 设置a节点的download属性值
        //   a.href = dataURL; // 将图片的src赋值给a节点的href
        //   a.dispatchEvent(event);
        // });
      } else {
        let canvas = document.querySelector(".applt-qrcode");
        let dataURL = canvas.toDataURL("image/png");
        let a = document.createElement("a"); // 创建一个a节点插入的document
        let event = new MouseEvent("click"); // 模拟鼠标click点击事件
        a.download = "paycode.png"; // 设置a节点的download属性值
        a.href = dataURL; // 将图片的src赋值给a节点的href
        a.dispatchEvent(event);
      }
    },
    createTable() {
      this.$refs.addTableForm.validate((valid) => {
        if (valid) {
          let classify = this.classifyList.find(
            (val) => val.shoppingTableConfigId == this.addTableForm.shoppingTableConfigId
          );
          if (!classify) {
            this.$notify({
              title: "提示",
              message: "桌位类型不存在，请重新配置",
              type: "error",
              duration: 2000,
            });
            return;
          }
          this.addTableForm.capacity = classify.max;
          let params = JSON.parse(JSON.stringify(this.addTableForm));
          this.updateEdcShopTable(params);
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    bindCode() {
      if (
        (parseInt(this.bindCodeForm.bindCode) !==
          parseFloat(this.bindCodeForm.bindCode) ||
          this.bindCodeForm.bindCode.length > 8) &&
        !this.bindCodeType
      ) {
        this.$notify({
          title: "提示",
          message: "绑定码需为不超过 8 位的整数",
          type: "error",
          duration: 2000,
        });
        return;
      }
      this.$refs.bindCodeForm.validate((valid) => {
        if (valid) {
          if (!this.bindCodeType) {
            let classify = this.classifyList.find(
              (val) =>
                val.shoppingTableConfigId == this.bindCodeForm.shoppingTableConfigId
            );
            if (!classify) {
              this.$notify({
                title: "提示",
                message: "桌位类型不存在，请重新配置",
                type: "error",
                duration: 2000,
              });
              return;
            }
            this.bindCodeForm.capacity = classify.max;
            let params = JSON.parse(JSON.stringify(this.bindCodeForm));
            this.updateShoppingTableBindCode(params);
          } else {
            this.isSubmit = true;
            bindWhdcQrCode({
              mtype: 3,
              qrCodeNo: this.bindCodeForm.bindCode,
              shoppingTableId: this.bindCodeForm.shoppingTableId,
              moreQrParams: `qrCodeValue=${
                localStorage.shopId + "-" + String(this.bindCodeForm.shoppingTableId)
              }`,
            }).then((res) => {
              if (res.code == 1) {
                this.dialogBindCodeVisible = false;
                this.$notify({
                  title: "提示",
                  message: "绑定成功",
                  type: "success",
                  duration: 2000,
                });
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
              this.isSubmit = false;
            });
          }
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    openAutoCreate() {
      this.dialogAutoCreateVisible = true;
    },
    autoCreate() {
      if (this.autoCreateForm.tableCount.length == 0) {
        this.$notify({
          title: "警告",
          message: "餐桌数量不能为空",
          type: "warning",
          duration: 2000,
        });
        return;
      }
      this.$refs.autoCreateForm.validate((valid) => {
        if (valid) {
          autoCreateEdcShopTable({
            tableCount: this.autoCreateForm.tableCount,
          }).then((res) => {
            if (res.code == 1) {
              this.$notify({
                title: "提示",
                message: "生成成功",
                type: "success",
                duration: 2000,
              });
              this.dialogAutoCreateVisible = false;
              this.getNextData();
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "error",
                duration: 2000,
              });
            }
          });
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .tab-content {
    display: block;
    padding: 20px;
    .list {
      .name,
      .item-count {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .el-dialog {
    .el-select {
      width: 100%;
    }
  }
  .tab-header {
    .btn-group-one {
      .upload-xls {
        display: inline-block;
        margin: 0 15px;
      }
    }
    .btn-group-two {
      .el-checkbox {
        margin-right: 15px;
      }
    }
  }
}
</style>

<style lang="less">
.el-transfer-panel__item {
  display: block;
}
.table-page {
  .transfer-body {
    .el-dialog__body {
      padding-right: 10px;
    }
    .el-transfer-panel__item {
      display: block;
    }
    .el-transfer-panel {
      width: 220px;
    }
  }
  .el-tabs__item.is-top {
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.list {
  .el-checkbox {
    width: 100%;
    .el-checkbox__label {
      width: 80%;
    }
  }
}
.applt-qrcode {
  width: 300px;
  height: 300px;
  display: block;
  margin: 10px 0 10px 20px;
}
</style>
